import React from 'react';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

export default function FAQ_2() {
    return (
        <Accordion>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        I would like to use my own riders to collect my arrived goods. Is this possible?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                        Yes. If you would like to use your own riders, you can have them collect the items from our Nairobi CBD office. We are open Monday to Friday, 9:00AM to 5:00PM.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        What happens if the items that is delivered is not what I ordered?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                        Once you receive deliveries, as always ensure it is what you ordered and 
                        is in perfect working condition according to the description given. 
                        If there is an issue while you are receiving items, you have the right to reject it 
                        and have it returned.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        How soon will I receive my package after requesting for delivery?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                        For deliveries within Nairobi, all requests made before 11 am will be handled the same day. 
                        Any delivery requests after will get to you by midday the next day. 
                        For outbound (deliveries outside Nairobi), you will receive your packages the next morning.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        How long should I wait before requesting for a delivery?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                    <p>
                        You can and should request for delivery as soon as you are notified that your goods have arrived. 
                        However, goods stored for more than 14 days will attract storage fees depending on size and weight.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
        </Accordion>
    );
}
